<template>
<div>
  <!--更新服务 - tab栏-->
  <div v-if="addObj.isAdd === 3" style="margin: 0 20px">
    <div class="line-tab">
      <div :class="item.index === indexActive ? 'select-active1' : 'no-select1'" v-for="item in tabs" :key="item.index" @click="selectTab(item)">
        <span>{{item.name}}</span>
      </div>
      <div style="float: right;" v-if="addObj.isAdd === 3 && indexActive === 1"><el-button type="primary" round @click="openHandShow()">补填服务记录</el-button></div>
    </div>
  </div>
  <!-- 选择服务对象 -->
  <div v-if="indexActive === 0" style="margin: 10px 20px">
    <div v-if="addObj.isAdd === 1 && isShowPerson">
      <el-radio-group size="small" v-model="labelval" @change="changelabel">
        <el-radio-button :label="1">姓名查询</el-radio-button>
        <el-radio-button :label="0">条件查询</el-radio-button>
      </el-radio-group>
      <el-autocomplete v-if="labelval === 1" size="small" style="width: 360px" class="inline-input" v-model="personName"
                       :fetch-suggestions="querySearch" placeholder="请输入服务对象姓名" :trigger-on-focus="false" @select="handleSelect">
      </el-autocomplete>
    </div>
    <div style="margin-top: 10px" v-if="addObj.isAdd === 1 && isShowPerson">
      <el-row v-if="labelval === 0">
        <el-col :span="8">
          <el-cascader v-fixZoom size="small" style="width: 100%" :options="orgOptions" v-model="oid" :filterable="true" placeholder="请选择组织"
                       :props="{ checkStrictly: true, value: 'id', label: 'name', children: 'child', emitPath: false}"
                       ref="orgOptions" @change="selectOrgID">
          </el-cascader>
        </el-col>
        <el-col :span="8">
          <el-select v-fixZoom size="small" v-model="cid" filterable  :placeholder="isCenterName" style="width: 100%" @change="selectCommunityID">
            <el-option v-for="item in orgcommunitys" :key="item.value" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="8">
          <el-select v-fixZoom size="small" style="width: 100%" v-model="hid" :placeholder="isRightName" @change="selectHomeID">
            <el-option v-for="item in selectorghomes" :key="item.id" :label="item.address" :value="item.id">
              <span style="">{{ item.address }}</span>&nbsp;
              <span style="color: #8492a6; font-size: 12px">{{ item.telephone }}</span>
            </el-option>
          </el-select>
        </el-col>
      </el-row>
      <el-row style="margin-top: 10px">
        <el-col :span="12" v-if="labelval === 0">
          <el-select v-fixZoom size="small" v-model="orderForm.personId" placeholder="请选择服务对象" style="width: 100%" @change="selectPerson">
            <el-option v-for="item in selectoldpersons" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </el-col>
      </el-row>
    </div>
    <div style="margin-top: 5px">
      <el-table :data="personTable" border style="border: 1px solid #3D83F3;width: 100%" highlight-current-row ref="singleTable" size="mini"
                :header-cell-style="getBackgroundColor"
                :row-class-name="tableRowClassName"
                :cellStyle="cellStyle">
        <el-table-column prop="name" label="姓名" min-width="60" align="center"></el-table-column>
        <el-table-column label="性别" width="60" align="center">
          <template slot-scope="scope">
            <span>{{getSex(scope.row.sex)}}</span>
          </template>
        </el-table-column>
        <el-table-column v-if="addObj.isAdd === 1" prop="idcard_num" label="身份证号" min-width="70" align="center"></el-table-column>
        <el-table-column prop="h_address" label="家庭地址" min-width="100" align="center"></el-table-column>
      </el-table>
      <el-form size="small" style="margin: 20px 0 0" :model="orderForm" :rules="orderRules" ref="orderForm" label-width="100px" class="demo-ruleForm my-form">
        <el-row>
          <el-col :span="12" style="padding-right: 10px;box-sizing: border-box">
            <el-form-item label="服务地址" prop="backup_address">
              <el-input :disabled="addObj.isAdd === 3" class="my-form-inpt" v-model="orderForm.backup_address" placeholder="请输入"></el-input>
            </el-form-item>
            <el-form-item label="服务开始时间" prop="sTime">
              <el-date-picker v-fixZoom :disabled="addObj.isAdd === 3" class="my-form-inpt" value-format="yyyy-MM-dd HH:mm:ss" :clearable="false" style="width: 100%"
                              v-model="orderForm.sTime" type="datetime" placeholder="请选择" default-time="10:00:00">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12" style="padding-left: 10px;box-sizing: border-box">
            <el-form-item label="联系电话" prop="backup_phone">
              <el-input :disabled="addObj.isAdd === 3" class="my-form-inpt" type="number" v-model="orderForm.backup_phone" placeholder="请输入"></el-input>
            </el-form-item>
            <el-form-item label="服务内容" prop="st_id">
              <el-cascader v-fixZoom class="my-form-inpt" :disabled="addObj.isAdd !== 1" style="width: 100%" :options="typeTree" v-model="orderForm.st_id" :filterable="true" placeholder="请选择"
                           :props="{ checkStrictly: true, value: 'id', label: 'typename', children: 'child', emitPath: false, disabled: 'isService'}" ref="typeOptions" @change="changeType">
                <template #default="{data}">
                  <span v-if="data.is_service !== 1" style="font-style: italic;color: #999999">{{ data.typename}}</span><strong v-else style="color: #1a1a1a;">{{ data.typename}}</strong>
                </template>
              </el-cascader>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12" prop="" v-if="!showPssType"  style="padding-right: 10px;box-sizing: border-box">
            <el-form-item label="下次生成时间" prop="next_time">
              <el-date-picker v-fixZoom :disabled="addObj.isAdd === 3" class="my-form-inpt"
                              value-format="yyyy-MM-dd HH:mm:ss" :clearable="false" style="width: 100%"
                              v-model="orderForm.next_time" type="datetime" placeholder="请选择" default-time="10:00:00"
                              :picker-options="pickerOptions">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12" :style="{ paddingLeft: showPssType ? '0px' : '10px', boxSizing: 'border-box' }">
            <el-form-item label="服务时长" prop="">
              <el-input :disabled="addObj.isAdd === 3" class="my-form-inpt" type="number" placeholder="请输入" v-model="orderForm.times">
                <template slot="append">小时</template>
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item v-if="orderForm.st_id !== ''" label="服务商" prop="">
          <el-radio-group :disabled="addObj.isAdd === 3" style="margin-left: 10px;width: 150px" v-model="orderForm.islevel1" @change="changeLevel1">
            <el-radio :label="1">不限</el-radio><el-radio :label="2">指派</el-radio>
          </el-radio-group>
          <el-select v-fixZoom class="my-form-inpt" :disabled="addObj.isAdd === 3 || addObj.isAdd === 2" v-model="orderForm.ss_id" placeholder="请选择" style="width: calc(100% - 165px);" @change="changeSoid">
            <el-option v-for="item in soOptions" :key="item.id" :label="item.showName" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="服务人员" prop="" v-if="orderForm.ss_id !== ''">
          <el-radio-group :disabled="addObj.isAdd === 3" style="margin-left: 10px;width: 150px" v-model="orderForm.islevel2" @change="changeLevel2">
            <el-radio :label="1">不限</el-radio><el-radio :label="2">指派</el-radio>
          </el-radio-group>
          <el-select v-fixZoom class="my-form-inpt" :disabled="addObj.isAdd === 3" v-model="orderForm.supplier_person_id" style="width: calc(100% - 165px);" placeholder="请选择">
            <el-option v-for="item in supplierorgpersons" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="服务频率" prop="" v-if="!showPssType">
          <!--        addObj.isAdd === 3-->
          <el-radio-group :disabled="true" style="margin-left: 10px;width: 150px" v-model="orderForm.pss_type" @change="changetype">
            <el-radio :label="1">单次</el-radio><el-radio :label="2">循环</el-radio>
          </el-radio-group>
          <el-select v-fixZoom class="my-form-inpt" v-if="orderForm.pss_type === 2" :disabled="addObj.isAdd === 3" v-model="orderForm.frequency_id" style="width: calc(100% - 165px);" placeholder="请选择">
            <el-option v-for="item in optionFrequency" :key="item.id" :label="item.frequency" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <!--  拓展字段  -->
        <el-row>
          <el-col :span="12" v-for="(item, index) in serviceList" :key="index" style="box-sizing: border-box" :style="{paddingLeft: index % 2 === 0 ? '' : '10px', paddingRight: index % 2 === 0 ? '10px' : ''}">
            <div style="height: 50px">
              <div style="height: 32px;line-height:32px;font-size:14px;text-align:center;width: 90px;float: left;color: #ffffff;background: #3D83F3;
                border-radius: 5px 5px 5px 5px;"><span v-if="item.required === 1" style="color: #F56C6C">*</span><span>{{item.key}}</span></div>
              <div style="height: 32px;width: calc(100% - 100px);margin-left: 10px;float: left"><el-input class="my-form-inpt" :disabled="addObj.isAdd === 3" size="small" v-model="item.value" placeholder="请输入"></el-input></div>
            </div>
          </el-col>
        </el-row>
        <el-form-item label="备注" prop="">
          <el-input class="my-form-inpt" :disabled="addObj.isAdd === 3" v-model="orderForm.remark" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="服务项目包" prop="">
          <el-select v-fixZoom class="my-form-inpt" :disabled="addObj.isAdd === 3" v-model="orderForm.spb_id" placeholder="请选择（不关联留空）" clearable style="width: 100%">
            <el-option :value="0" label="不关联"></el-option>
            <el-option v-for="item in bundleOptions" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </div>
    <div style="height: 60px;padding-top: 10px" v-if="addObj.isAdd !== 3">
      <el-row style="margin: 0 30px">
        <el-col :span="12">
          <div class="cancel-btn1" @click="closeAdd()"><span>取消</span></div>
        </el-col>
        <el-col :span="12">
          <div class="send-btn1" @click="submitAddEdit('orderForm')"><span>确定</span></div>
        </el-col>
      </el-row>
    </div>
  </div>
  <!-- 历史处理 -->
  <div v-if="addObj.isAdd === 3 && indexActive === 1">
    <div style="height: 430px;overflow-y:auto;margin: 20px">
      <el-table :header-cell-style="getBackgroundColor1" size="mini" :data="tableData" border style="width: 100%;font-size: 14px" highlight-current-row ref="singleTable">
        <el-table-column type="index" label="序号" width="50" align="center"> </el-table-column>
        <el-table-column prop="person_name" label="长者姓名" min-width="50" align="center"></el-table-column>
        <el-table-column prop="service_name" label="服务内容" min-width="100" align="center"></el-table-column>
        <el-table-column prop="svs_tm" label="服务时间" width="160" align="center"></el-table-column>
        <el-table-column prop="remark" label="备注" min-width="90" align="center"></el-table-column>
        <el-table-column prop="supplier_name" label="服务商" min-width="80" align="center"></el-table-column>
        <el-table-column prop="supplier_person_name" label="服务人员" min-width="50" align="center"></el-table-column>
        <el-table-column align="center" label="操作" width="50">
          <template slot-scope="scope">
            <el-button type="text" @click="handleClick(scope.row)" size="mini">详情</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div style="margin-top: 5px;height: 40px;text-align: center">
      <el-pagination v-fixZoom size="mini" @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
                     :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="totalCells">
      </el-pagination>
    </div>
  </div>
  <!--  更新服务单 按钮  -->
  <div style="height: 60px;padding-top: 10px" v-if="addObj.isAdd === 3">
    <div>
      <el-row style="margin: 0 30px">
        <el-col :span="12">
          <div class="cancel-btn1" @click="closeService()"><span>取消</span></div>
        </el-col>
        <el-col :span="12">
          <div class="send-btn1" @click="delService()"><span>结束服务单</span></div>
        </el-col>
      </el-row>
    </div>
  </div>
  <!-- 服务单详情 -->
  <el-dialog width="800px" :visible.sync="detailsShow" v-if="detailsShow" center append-to-body class="all-open">
    <div class="title-top-alarm">
      <div><span>服务单详情</span></div>
      <div class="line-title"></div>
      <order-content :orderObj="orderInfoObj"></order-content>
    </div>
  </el-dialog>
  <!-- 补填服务记录 -->
  <el-dialog width="800px" :visible.sync="recordShow" v-if="recordShow" center append-to-body class="all-open">
    <div class="title-top-alarm">
      <div><span>处理服务单</span></div>
      <div class="line-title"></div>
    </div>
    <order-handle-open :soOptions="soOptions" :orderObj="addObj" v-model="recordShow" @closeOrder="closeOrder"></order-handle-open>
  </el-dialog>
</div>
</template>

<script>
import {querycommunitybyorgids} from '../../../api/organizer'
import {queryhomebycids} from '../../../api/relation'
import {queryoldpersonbyhids} from '../../../api/handlealarm'
import {
  querysupplierservice,
  addpersonsupplierservice,
  updatepersonsupplierservice, querypersonsupplierservicerecords,
  querysupplierorgperson, deletepersonsupplierservice,
  queryserviceprojectbundle
} from '../../../api/serviceMark'
import {searcholdperson} from '../../../api/serviceObject'
import orderHandleOpen from './orderHandleOpen.vue'
import orderContent from '../../servicemanagement/childComponents/orderContent.vue'

export default {
  name: 'addServiceOrder',
  model: {
    prop: 'addServiceOrderShow',
    event: 'change'
  },
  props: {
    addObj: {
      type: Object,
      default: null
    }
  },
  components: {orderContent, orderHandleOpen},
  data () {
    return {
      active: 0,
      tabs: [
        {index: 0, name: '服务信息'},
        {index: 1, name: '历史处理'}
      ],
      indexActive: 0,
      labelval: 1,
      orgOptions: [], // 组织
      oid: '', // 组织id
      orgcommunitys: [], // 小区
      checkAll1: false,
      checkAll2: false,
      personTable: [],
      cid: '', // 小区id
      selectorghomes: [], // 家庭
      hid: '', // 家庭id
      selectoldpersons: [], // 服务对象
      isCenterName: '',
      isRightName: '',
      checkShowName1: '',
      checkShowName2: '',
      typeTree: [], // 服务内容
      soOptions: [], // 服务商
      optionFrequency: [], // 服务频率
      supplierorgpersons: [], // 服务商人员
      pickerOptions: {
        disabledDate (time) {
          return time.getTime() < Date.now()
        }
      },
      personName: '',
      showPssType: false,
      orderForm: {
        id: 0,
        pid: '',
        pids: [],
        personId: '',
        st_id: '',
        ss_id: '', // 服务内容id
        s_e_tm: null,
        pss_type: 1,
        is_cycle: 1,
        islevel: 2,
        islevel1: 2,
        islevel2: 2,
        sys_person_id: 0,
        supplier_org_id: 0,
        supplier_person_id: '',
        frequency_id: '',
        svs_tm: '',
        service_person: '',
        remark: '',
        so_id: '',
        serviceRemark: '',
        backup_phone: '',
        backup_address: '',
        times: 4, // 服务时长
        sTime: '', // 开始时间
        next_time: '',
        spb_id: 0 // 服务项目包ID（0=未关联）
      },
      bundleOptions: [], // 服务项目包列表
      orderRules: {
        username: [{ required: true, message: '请输入用户名', trigger: 'blur' }],
        pid: [{ required: true, message: '请选择服务对象', trigger: 'change' }],
        st_id: [{ required: true, message: '请选择服务内容', trigger: 'change' }],
        ss_id: [{ required: true, message: '请选择服务商', trigger: 'change' }],
        supplier_person_id: [{ required: true, message: '请选择服务人员', trigger: 'change' }],
        frequency_id: [{ required: true, message: '请选择服务频率', trigger: 'change' }],
        backup_phone: [{ required: true, message: '请输入联系电话', trigger: 'blur' }],
        backup_address: [{ required: true, message: '请输入服务地址', trigger: 'blur' }],
        times: [{ required: true, message: '请输入服务时长', trigger: 'blur' }],
        sTime: [{ required: true, message: '请选择服务开始时间', trigger: 'change' }],
        next_time: [{ required: true, message: '请选择派单时间', trigger: 'change' }]
      },
      moduletag: '',
      pageSize: 10,
      currentPage: 1,
      totalCells: 0,
      tableData: [],
      detailsShow: false,
      orderInfoObj: {
        row: '',
        type: 'order'
      },
      // 具体服务内容 拓展字段
      serviceList: [],
      sureArr: [], // 处理确认
      pictureArr: [],
      // 补填服务记录
      recordShow: false,
      isShowPerson: true
    }
  },
  created () {
    this.optionFrequency = this.addObj.frequencys
    this.getOrgOptions()
    this.moduletag = this.$store.state.user.moduletag
    if (this.moduletag === 1) {
      this.isRightName = '请选择已有家庭'
      this.isCenterName = '请选择小区'
      this.checkShowName1 = '小区'
      this.checkShowName2 = '家庭'
    } else if (this.moduletag === 2) {
      this.isRightName = '请选择已有房间'
      this.isCenterName = '请选择机构'
      this.checkShowName1 = '机构'
      this.checkShowName2 = '房间'
    } else { // 3
      this.isRightName = '请选择已有家庭/房间'
      this.isCenterName = '请选择小区/机构'
      this.checkShowName1 = '小区/机构'
      this.checkShowName2 = '家庭/房间'
    }
    this.getTypeTree()
    this.getBundleOptions()
    if (this.addObj.isAdd === 2 || this.addObj.isAdd === 3) {
      // this.active = 1
      this.active = 0
      let item = {
        id: this.addObj.row.pid,
        name: this.addObj.row.person_name,
        sex: this.addObj.row.person_sex,
        // idcard_num: this.addObj.row.person_name,
        h_address: this.addObj.row.home_address
      }
      this.personTable = [item]
      // console.log(this.addObj.row)
      this.orderForm.id = this.addObj.row.id
      this.orderForm.pid = this.addObj.row.pid
      this.orderForm.st_id = this.addObj.row.st_id
      if (this.addObj.row.ss_id === 0) {
        // 抢单
        this.orderForm.islevel = 2
      } else {
        // 指派
        this.getAllService()
        this.orderForm.islevel = 1
      }
      this.orderForm.supplier_org_id = this.addObj.row.supplier_org_id
      this.orderForm.supplier_person_id = this.addObj.row.supplier_person_id
      this.orderForm.pss_type = this.addObj.row.pss_type
      this.orderForm.ss_id = this.addObj.row.ss_id
      this.orderForm.frequency_id = this.addObj.row.frequency_id
      this.orderForm.remark = this.addObj.row.remark
      this.orderForm.backup_phone = this.addObj.row.backup_phone
      this.orderForm.backup_address = this.addObj.row.backup_address
      this.orderForm.times = this.util.getTimeDifference(this.addObj.row.begin_time, this.addObj.row.end_time)
      this.orderForm.sTime = this.addObj.row.begin_time
      this.orderForm.spb_id = this.addObj.row.spb_id || 0
      // this.orderForm.next_time = this.addObj.row.next_time
      // 计算明天的时间
      const tomorrow = new Date()
      tomorrow.setDate(tomorrow.getDate() + 1)
      tomorrow.setHours(0, 0, 0, 0)
      // 判断 next_time 是否小于明天的时间
      if (this.addObj.row.next_time && new Date(this.addObj.row.next_time) < tomorrow) {
        this.orderForm.next_time = ''
      } else {
        this.orderForm.next_time = this.addObj.row.next_time
      }
      if (this.addObj.row.begin_time !== '' && this.addObj.row.end_time !== '') {
        let times = new Date(this.addObj.row.end_time).getTime() - new Date(this.addObj.row.begin_time).getTime()
        let hours = times / (1000 * 60 * 60)
        this.orderForm.times = hours
        this.orderForm.s_e_tm = [this.addObj.row.begin_time, this.addObj.row.end_time]
      }
      let obj = this.addObj.row
      this.serviceList = []
      obj.servicerequirements = [[], []]
      obj.pictureArr = []
      if (obj !== '') {
        try {
          obj.servicerequirements = JSON.parse(obj.service_requirements)
          obj.pictureArr = JSON.parse(obj.picture_requirements)
        } catch (error) {}
      }
      this.serviceList = obj.servicerequirements[0]
      this.sureArr = obj.servicerequirements[1]
      this.pictureArr = obj.pictureArr
      if (this.addObj.row.pss_type === 1) {
        this.showPssType = true
      }
    } else {
      // add
      this.orderForm.pss_type = this.addObj.pssType
      if (this.addObj.pssType === 1) {
        this.showPssType = true
      }
    }
    if (this.orderForm.supplier_org_id !== 0) {
      this.querySupplierPerson()
    }
    if (this.addObj.isAdd === 3) {
      this.queryServiceRecords()
    }
    let old = this.store2.state.other.serviceInfo.oldPerson
    if (old !== '') {
      this.orderForm.personId = old.id
      this.personTable = [old]
      this.orderForm.backup_address = old.h_address
      this.orderForm.backup_phone = old.phone
      this.isShowPerson = false
    }
    setTimeout(() => {
      let obj = {
        oldPerson: ''
      }
      this.store2.dispatch('other/update_handle_service', obj)
    }, 1000)
  },
  methods: {
    // 查询服务项目包列表
    getBundleOptions () {
      let params = { page: 1, size: 9999 }
      let data = { oid: 0, name: '' }
      queryserviceprojectbundle(params, data).then(res => {
        this.bundleOptions = res.data.list || []
      }).catch(() => {})
    },
    changeLevel1 (val) {
      if (val === 1) {
        this.orderForm.ss_id = ''
        this.orderForm.supplier_person_id = ''
      }
    },
    changeLevel2 (val) {
      if (val === 1) {
        this.orderForm.supplier_person_id = ''
      }
    },
    selectTab (item) {
      this.indexActive = item.index
    },
    changelabel (val) {
      if (val === 1) {
        this.personName = ''
      }
    },
    // 姓名搜索服务对象
    querySearch (queryString, cb) {
      if (queryString.length < 1) {
        let arr = []
        cb(arr)
        return
      }
      let data = {
        lessname: queryString,
        page: 1,
        size: 9999
      }
      searcholdperson(data).then(res => {
        let re = []
        this.selectoldpersons = res.data.persons
        res.data.persons.forEach(item => {
          re.push({
            value: item.name + '(' + item.h_address + ')',
            row: item,
            id: item.id
          })
        })
        if (re.length === 0) {
          this.$message({ message: '暂无该服务对象。', type: 'warning' })
        }
        cb(re)
      }).catch(() => {
        let arr = []
        cb(arr)
      })
    },
    handleSelect (item) {
      console.log('item', item)
      this.orderForm.personId = item.id
      this.selectPerson()
    },
    getSex (sex) {
      return this.util.getSex(sex + '')
    },
    // 获取服务记录
    queryServiceRecords () {
      let params = {
        page: this.currentPage,
        size: this.pageSize
      }
      let data = {
        pss_id: this.orderForm.id
      }
      querypersonsupplierservicerecords(params, data).then(res => {
        this.tableData = res.data.service
        this.totalCells = res.data.cnt
      }).catch(() => {})
    },
    handleSizeChange (val) {
      this.pageSize = val
      this.queryServiceRecords()
    },
    handleCurrentChange (val) {
      this.currentPage = val
      this.queryServiceRecords()
    },
    handleClick (row) {
      this.orderInfoObj.row = row
      this.detailsShow = true
    },
    // 服务商人员
    querySupplierPerson () {
      let data = {
        so_id: this.orderForm.supplier_org_id
      }
      querysupplierorgperson(data).then(res => {
        this.supplierorgpersons = res.data.supplierorgpersons
      }).catch(() => {})
    },
    getOrgOptions () {
      let lastLevel = 100
      const arr = this.addObj.treeData
      for (let i = 0; i < arr.length; i++) {
        if (arr[i].level < lastLevel) {
          lastLevel = arr[i].level
        }
      }
      for (let i = 0; i < arr.length; i++) {
        if (arr[i].level === lastLevel) {
          this.orgOptions.push(arr[i])
        }
      }
      for (let i = 0; i < this.orgOptions.length; i++) {
        const child = this.arrayToNode(arr, this.orgOptions[i].id)
        if (child.length !== 0) {
          this.orgOptions[i].child = child
        }
      }
    },
    // 递归
    arrayToNode (nodesArray, pid) {
      const vm = this
      return nodesArray.filter(value => {
        if (value.orgpid === pid) {
          const arrayToNode = vm.arrayToNode(nodesArray, value.id)
          if (arrayToNode.length > 0) {
            value.child = arrayToNode
          }
          return value
        }
      })
    },
    // 根据服务类型获取服务商内容
    getAllService () {
      let params = {
        page: 1,
        size: 99999
      }
      let data = {
        st_id: this.orderForm.st_id
      }
      querysupplierservice(params, data).then(res => {
        this.soOptions = res.data.service.filter(val => {
          val.showName = val.supplier_org_name
          let p = ''
          if (val.price !== '') {
            p = parseFloat(val.price) / 100 + '元'
            val.showName = val.showName + ' - ' + p
          }
          if (val.time_duration !== '') {
            if (val.price === '') {
              val.showName = val.showName + ' - ' + val.time_duration + '分钟'
            } else {
              val.showName = val.showName + '/' + val.time_duration + '分钟'
            }
          }
          return val
        })
        if (this.soOptions.length === 0) {
          // this.$message.warning('该服务内容暂无服务商绑定。')
          this.orderForm.ss_id = ''
          this.orderForm.supplier_person_id = ''
        }
        console.log(this.soOptions)
      }).catch(() => {
        this.loading = false
      })
    },
    changetype (id) {
      if (id === 1) {
        this.orderForm.frequency_id = ''
      }
    },
    changeSoid (id) {
      this.orderForm.supplier_org_id = 0
      for (let i = 0; i < this.soOptions.length; i++) {
        if (this.soOptions[i].id === id) {
          this.orderForm.supplier_org_id = this.soOptions[i].so_id
          this.querySupplierPerson()
        }
      }
    },
    getTypeTree () {
      let lastLevel = 100
      const arr = this.clone(this.addObj.types)
      for (let i = 0; i < arr.length; i++) {
        arr[i].isService = false
        if (arr[i].is_service === 0) {
          arr[i].isService = true
        }
        if (arr[i].level < lastLevel) {
          lastLevel = arr[i].level
        }
      }
      for (let i = 0; i < arr.length; i++) {
        if (arr[i].level === lastLevel) {
          this.typeTree.push(arr[i])
        }
      }
      for (let i = 0; i < this.typeTree.length; i++) {
        const child = this.arrayToNode1(arr, this.typeTree[i].id)
        if (child.length !== 0) {
          this.typeTree[i].child = child
        }
      }
    },
    // 递归
    arrayToNode1 (nodesArray, pid) {
      const vm = this
      return nodesArray.filter(value => {
        if (value.upid === pid) {
          const arrayToNode = vm.arrayToNode1(nodesArray, value.id)
          if (arrayToNode.length > 0) {
            value.child = arrayToNode
          }
          return value
        }
      })
    },
    selectOrgID (id) {
      this.cid = ''
      this.orgcommunitys = []
      this.selectorghomes = []
      this.hid = ''
      this.checkAll1 = false
      this.checkAll2 = false
      let data = {
        orgids: [id]
      }
      querycommunitybyorgids(data).then(res => {
        this.orgcommunitys = res.data.communitys
      }).catch(() => {})
    },
    selectCommunityID (id) {
      this.selectorghomes = []
      this.hid = ''
      this.checkAll1 = false
      this.checkAll2 = false
      this.orderForm.pid = ''
      let data = {
        cids: [id]
      }
      queryhomebycids(data).then(res => {
        this.selectorghomes = res.data.homes
        let ids = []
        this.selectorghomes.forEach(item => {
          ids.push(item.id)
        })
        this.selectHomeIDs(ids)
      }).catch(() => {})
    },
    selectHomeIDs (ids, isSelect) {
      this.orderForm.pid = ''
      this.checkAll2 = false
      let data = {
        hids: ids
      }
      queryoldpersonbyhids(data).then(res => {
        this.selectoldpersons = res.data.persons
        if (isSelect) {
          this.hid = ''
          console.log(this.personTable)
          let selectids = []
          this.personTable.forEach(item => {
            selectids.push(item.id)
          })
          for (let i = 0; i < this.selectoldpersons.length; i++) {
            if (selectids.indexOf(this.selectoldpersons[i].id) === -1) {
              this.personTable.push(this.selectoldpersons[i])
              this.orderForm.pid = 0
            }
          }
        }
      }).catch(() => {})
    },
    selectHomeID (id) {
      this.orderForm.pid = ''
      let data = {
        hids: [id]
      }
      queryoldpersonbyhids(data).then(res => {
        this.selectoldpersons = res.data.persons
      }).catch(() => {})
    },
    selectPerson () {
      console.log(this.selectoldpersons)
      for (let i = 0; i < this.selectoldpersons.length; i++) {
        if (this.orderForm.personId === this.selectoldpersons[i].id) {
          this.personTable = [this.selectoldpersons[i]]
          this.orderForm.backup_address = this.selectoldpersons[i].h_address
          this.orderForm.backup_phone = this.selectoldpersons[i].phone
        }
      }
    },
    changeType (id) {
      console.log(this.orderForm.st_id)
      const arr = this.clone(this.addObj.types)
      let obj = ''
      this.serviceList = []
      arr.forEach(item => {
        if (item.id === id) {
          obj = item
        }
      })
      obj.servicerequirements = [[], []]
      obj.pictureArr = []
      if (obj !== '') {
        try {
          obj.servicerequirements = JSON.parse(obj.service_requirements)
          obj.pictureArr = JSON.parse(obj.picture_requirements)
        } catch (error) {}
      }
      this.serviceList = obj.servicerequirements[0]
      this.sureArr = obj.servicerequirements[1]
      this.pictureArr = obj.pictureArr
      this.getAllService()
    },
    lastStep () {
      this.active = 0
    },
    closeAdd () {
      this.$emit('change', false)
    },
    submitAddEdit (formName) {
      if (this.addObj.isAdd === 1) {
        let pids = []
        this.personTable.forEach(item => {
          pids.push(item.id)
        })
        if (pids.length === 0) {
          this.orderForm.pid = ''
        } else {
          if (pids.length === 1) {
            this.orderForm.pid = pids[0]
          } else {
            this.orderForm.pid = 0
          }
          this.orderForm.pids = pids
        }
      }
      if (this.orderForm.pid === 0 || this.orderForm.pid === '') {
        this.$message({ message: '请选择服务对象。', type: 'warning' })
        return
      }
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let servicerequirementstag = 0
          let servicerequirements = []
          let arr0 = []
          if (this.serviceList.length > 0) {
            servicerequirementstag = 1
          }
          let isTrue = false
          this.serviceList.forEach(item => {
            if (item.key !== '') {
              let obj = {key: item.key, value: item.value, required: (item.required || item.required === 0) ? item.required : 0}
              if (item.required === 1 && item.value === '') {
                this.$message({ message: item.key + '字段需填完整。', type: 'warning' })
                isTrue = true
              }
              arr0.push(obj)
            }
          })
          if (isTrue) {
            return
          }
          servicerequirements[0] = arr0
          servicerequirements[1] = this.sureArr
          let num = new Date(this.orderForm.sTime).getTime()
          let numTime = 1
          if (this.orderForm.times !== '') {
            numTime = this.orderForm.times
          }
          let val = numTime * 60 * 60 * 1000
          let eTime = new Date(num + val)
          // eslint-disable-next-line no-extend-native
          Date.prototype.format = this.validate.format
          let endTime = eTime.format('yyyy-MM-dd hh:mm:ss')
          if (this.addObj.isAdd === 1) {
            let data = {
              'id': 0,
              'pid': this.orderForm.pid,
              'st_id': this.orderForm.st_id,
              'ss_id': this.orderForm.ss_id === '' ? 0 : this.orderForm.ss_id,
              // 'begin_time': this.orderForm.s_e_tm ? this.orderForm.s_e_tm[0] : '',
              // 'end_time': this.orderForm.s_e_tm ? this.orderForm.s_e_tm[1] : '',
              'begin_time': this.orderForm.sTime,
              'end_time': endTime,
              'pss_type': this.orderForm.pss_type,
              is_cycle: this.orderForm.pss_type,
              'sys_person_id': this.$store.state.user.syspersonid,
              'supplier_org_id': this.orderForm.supplier_org_id === '' ? 0 : this.orderForm.supplier_org_id,
              'supplier_person_id': this.orderForm.supplier_person_id === '' ? 0 : this.orderForm.supplier_person_id,
              frequency_id: this.orderForm.frequency_id === '' ? 0 : this.orderForm.frequency_id,
              pids: this.orderForm.pids,
              remark: this.orderForm.remark,
              service_requirements: JSON.stringify(servicerequirements),
              service_requirements_tag: servicerequirementstag,
              picture_requirements: JSON.stringify(this.pictureArr),
              picture_requirements_tag: this.pictureArr.length > 0 ? 1 : 0,
              backup_phone: this.orderForm.backup_phone,
              backup_address: this.orderForm.backup_address,
              service_from: 1,
              next_time: this.orderForm.next_time, // 循环单  下次派送时间
              spb_id: this.orderForm.spb_id || 0 // 服务项目包ID（0=未关联）
            }
            addpersonsupplierservice(data).then(res => {
              this.$notify({ title: '成功', message: '成功发起服务单', type: 'success', duration: 2000 })
              this.$emit('changeUpadte')
              this.$emit('change', false)
            }).catch(() => {
              this.$notify.error({ title: '失败', message: '发起服务单失败' })
            })
          } else if (this.addObj.isAdd === 2) {
            let data = {
              'id': this.orderForm.id,
              'ss_id': this.orderForm.ss_id === '' ? 0 : this.orderForm.ss_id,
              // 'begin_time': this.orderForm.s_e_tm ? this.orderForm.s_e_tm[0] : '',
              // 'end_time': this.orderForm.s_e_tm ? this.orderForm.s_e_tm[1] : '',
              'begin_time': this.orderForm.sTime,
              'end_time': endTime,
              'pss_type': this.orderForm.pss_type,
              is_cycle: this.orderForm.pss_type,
              'supplier_org_id': this.orderForm.supplier_org_id,
              'supplier_person_id': this.orderForm.supplier_person_id,
              remark: this.orderForm.remark,
              frequency_id: this.orderForm.frequency_id === '' ? 0 : this.orderForm.frequency_id,
              service_requirements: JSON.stringify(servicerequirements),
              service_requirements_tag: servicerequirementstag,
              picture_requirements: JSON.stringify(this.pictureArr),
              picture_requirements_tag: this.pictureArr.length > 0 ? 1 : 0,
              backup_phone: this.orderForm.backup_phone,
              backup_address: this.orderForm.backup_address,
              spb_id: this.orderForm.spb_id || 0 // 服务项目包ID（0=未关联）
            }
            // console.log(data)
            updatepersonsupplierservice(data).then(res => {
              this.$notify({ title: '成功', message: '成功更新服务单', type: 'success', duration: 2000 })
              this.$emit('changeUpadte')
              this.$emit('change', false)
            }).catch(() => {})
          } else {
            // 弃
            // let data = {
            //   'id': 0,
            //   'pid': this.orderForm.pid === '' ? 0 : this.orderForm.pid,
            //   'pss_id': this.orderForm.id, // 服务单id
            //   'remark': this.orderForm.serviceRemark,
            //   'svs_tm': this.orderForm.svs_tm,
            //   'sys_person_id': this.orderForm.sys_person_id,
            //   'supplier_org_id': this.orderForm.supplier_org_id,
            //   'supplier_person_id': this.orderForm.supplier_person_id,
            //   service_requirements: JSON.stringify(servicerequirements),
            //   service_requirements_tag: servicerequirementstag,
            //   picture_requirements: JSON.stringify(this.pictureArr),
            //   picture_requirements_tag: this.pictureArr.length > 0 ? 1 : 0
            // }
            // createpersonsupplierservicerecords(data).then(res => {
            //   this.$notify({ title: '成功', message: '成功处理', type: 'success', duration: 2000 })
            //   this.$emit('changeUpadte')
            //   this.$emit('change', false)
            // })
          }
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    delService () {
      let data = {
        id: this.orderForm.id
      }
      deletepersonsupplierservice(data).then(res => {
        this.$notify({ title: '成功', message: '删除成功', type: 'success', duration: 2000 })
        this.$emit('changeUpadte')
        this.$emit('change', false)
      }).catch(() => {})
    },
    closeService () {
      this.$emit('change', false)
    },
    // 补填服务记录
    openHandShow () {
      this.recordShow = true
    },
    closeOrder () {
      this.$emit('changeUpadte')
      this.closeAdd()
    },
    cellStyle ({row, column, rowIndex, columnIndex}) {
      return 'border-color:#3D83F3!important;'
    },
    getBackgroundColor () {
      return {backgroundColor: '#D6E7FF', color: '#3D83F3', borderColor: '#3D83F3'}
    },
    tableRowClassName () {
      return 'my-row'
    },
    getBackgroundColor1 () {
      return {backgroundColor: '#3D83F3', color: '#ffffff', borderColor: '#3D83F3'}
    }
  }
}
</script>

<style>
.el-table .my-row {
  background: #EFF6FF;
  color: #303032;
  border: 1px solid #3D83F3;
}
.el-table__empty-block{
  height: 35px!important;
  min-height: 35px!important;
}
</style>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/datamanagement/childComponents/addServiceOrder.vue